import {Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalSelectorComponent} from '../../yu-selector/modal-selector/modal-selector.component';
import {HapticsImpactManagerService} from '../../../../Services/Platform/Capacitor/haptics-impact-manager.service';

@Component({
  selector: 'app-filter-swiper',
  templateUrl: './filter-swiper.component.html',
  styleUrls: ['./filter-swiper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FilterSwiperComponent {

  @ViewChild('scrollArea') scrollArea: ElementRef<HTMLElement> | undefined;

  @Input() items: any[] = [];

  @Input() itemsValueField: string = 'id';
  @Input() itemsLabelField: string = 'nombre';

  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  @Input() multiple: boolean = false;
  @Input() disabledReset: boolean = false;

  get hasValue(): boolean {

    if (this.value == null) {
      return false;
    }

    if (Array.isArray(this.value)) {
      return this.value.length > 0;
    }
    
    return this.value !== '' && this.value !== 0;
  }

  constructor(
    protected modalCtrl: ModalController,
    protected hapticsImpactManager: HapticsImpactManagerService
  ) {
  }


  /**
   * Abrir modal para seleccionar un item
   *
   */
  async openModalSelector() {
    await this.hapticsImpactManager.hapticsImpactHeavy();

    const modal = await this.modalCtrl.create({
      component: ModalSelectorComponent,
      componentProps: {
        items: this.items,
        itemsValueField: this.itemsValueField,
        itemsLabelField: this.itemsLabelField,
        value: this.value,
        multiple: this.multiple,
        disabledReset: this.disabledReset,
      },
      cssClass: 'yu-modal',
    });

    modal.onDidDismiss().then(({data, role}) => {

      if (!data && role !== 'reset') {
        return;
      }

      this.doActionSelector(data);
    });

    await modal.present();
  }


  /**
   * Aplicar resultado del selector
   *
   */
  doActionSelector(value?: any) {

    if (this.multiple) {
      this.value = value || [];

    } else {
      this.setItem(value);
    }

    this.valueChange.emit(this.value);
  }


  /**
   * Acción sobre el item
   *
   */
  async doActionItem(value?: any) {
    await this.hapticsImpactManager.hapticsImpactHeavy();

    if (this.multiple) {
      this.setItemMultiple(value);

    } else {
      this.setItem(value);
    }

    this.valueChange.emit(this.value);
  }


  /**
   * Asignar el valor cuando es múltiple
   *
   */
  setItemMultiple(value?: any) {

    if (!this.value.includes(value)) {
      this.value.push(value);
      return;
    }

    const index = this.value.indexOf(value);

    if (index > -1) {
      this.value.splice(index, 1);
    }
  }


  /**
   * Asignar el valor
   *
   */
  setItem(value?: any) {

    if (value === this.value && !this.disabledReset) {
      this.value = this.getResetValue();
      setTimeout(() => this.scrollArea?.nativeElement?.scroll({left: 0, top: 0, behavior: 'smooth'}), 5);

      return;
    }

    this.value = value;

    setTimeout(() => {
      const element = document.querySelector('.selected');
      element?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
    }, 50);
  }


  /**
   * Obtener valor de reset según el tipo
   *
   */
  getResetValue(): string | number | null {
    const valueType = typeof this.value;

    if (valueType === 'number') {
      return 0;
    }

    if (valueType === 'string') {
      return '';
    }

    return null;
  }

}
